import { Component, OnInit } from '@angular/core';
import { ConnectionService } from '../../services/connection.service';
import { ViewersService } from '../../services/viewers.service';
import { ViewersComponent } from '../viewport/viewer/viewers.component';
import { OverlayBtnsComponent } from '../viewport/overlay-btns/overlay-btns.component';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { VRService } from '../../services/vr.service';

@Component({
  selector: 'app-vr',
  imports: [CommonModule, ViewersComponent, OverlayBtnsComponent],
  templateUrl: './vr.component.html',
  styleUrl: './vr.component.css'
})
export class VrComponent implements OnInit{

  private beenLoaded: boolean;
  public user: any;

  constructor( 
    private connectionService: ConnectionService, 
    private viewersService: ViewersService,
  ) {
    this.beenLoaded = false;
    this.user = localStorage.getItem('user')
  }

  ngOnInit(): void {
    this.viewersService.viewer3d.waitInitialize().subscribe(() => {
      this.connectionService.getLastVRView().then(
        (response) => {
          this.viewersService.load3dView(response.viewID)
        }
      )
    })
    

    this.connectionService.subscribeVRView().subscribe(
      response => {
        this.viewersService.load3dView(response.viewID)
        this.beenLoaded = true;
      }
    );
  }

  public isViewerLoaded(): boolean {
    return this.beenLoaded || (this.viewersService.viewer3d && this.viewersService.viewer3d.isInitialized() && this.viewersService.viewer3d.isLoaded())
  }
  
}
